import React, { ComponentProps, PropsWithChildren, useState } from "react"
import Helmet from "react-helmet"
import cn from "classnames"

import config from "helpers/config"
import { routes } from "constants/routing"
import useWindowSize from "hooks/useWindowSize"
import usePathname from "hooks/usePathname"
import useBodyOverflowHidden from "hooks/newUI/useOverflowHidden"
import Navigation from "layouts/RedesignedLayout/navigation"
import Cookies from "components/Cookies"
import Wallet from "./menus/Wallet"
import Orders from "./menus/Orders"

import styles from "./redesignedLayout.module.scss"

interface IProps extends PropsWithChildren {
	title?: string
	className?: string
	layoutClassName?: string
	helmet?: ComponentProps<typeof Helmet>
}

const menus: Record<string, React.ComponentType<{ onToggle: () => void }>> = {
	[routes.profile.wallets]: Wallet,
	[routes.history.root]: Orders,
}

const RedesignedLayout: React.FC<IProps> = ({
	title,
	helmet,
	children,
	className,
	layoutClassName,
}) => {
	const { smallTablet } = useWindowSize()
	const pathname = usePathname()
	const year = new Date().getFullYear()
	const [isSidebarOpen, setIsSidebarOpen] = useState(!smallTablet);

	useBodyOverflowHidden(smallTablet ? isSidebarOpen : false)

	const Menu = Object.entries(menus).find(([route, component]) =>
		`/${pathname}`.startsWith(route),
	)?.[1]

	return (
		<>
			{helmet && <Helmet {...helmet} />}
			<Navigation />
			<div className={cn(styles.layout, layoutClassName)}>
				{Menu && (
					<div className={cn(styles.sideBar, { [styles.sideBar___open]: isSidebarOpen })}>
						<Menu onToggle={() => setIsSidebarOpen(!isSidebarOpen)} />
					</div>
				)}
				<div className={styles.content}>
					{title && <h1>{title}</h1>}
					<div className={className}>{children}</div>
					<footer>
						<span>{config.departmentAddress}</span>
						<span>&copy; {year} {config.department}</span>
					</footer>
				</div>
			</div>
			<Cookies />
		</>
	)
}

export default RedesignedLayout
